import Vue from 'vue'

export default {
    UPDATE_PRESS (state, value) {
        Vue.set(state, 'press', value);
    },
  SET_PRESS (state, value) {
        this.commit('UPDATE_PRESS', value);
    },
    SET_SELECTED_PRESS (state,  value ) {
      Vue.set(state, 'selectedPress', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/press/mutations.js